export const hackathonTheme = {
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          "&.Mui-focused": {
            backgroundColor: "#E7EBF0",
          },
        },
        multiline: {
          backgroundColor: "#E7EBF0",
          color: "#1D1D1D",
          borderRadius: 0,
          "&:hover": {
            backgroundColor: "#E7EBF0",
          },
          "&:active": {
            backgroundColor: "#E7EBF0",
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#E7EBF0",
          color: "#1D1D1D",
          borderRadius: 0,
          "&:hover": {
            backgroundColor: "#E7EBF0",
          },
          "&:active": {
            backgroundColor: "#E7EBF0",
          },
          "&.Mui-focused": {
            backgroundColor: "#E7EBF0",
          },
        },
        input: {
          bgcolor: "grey.100",
          color: "text.dark",
          borderRadius: 0,
        },
        underline: {
          "&::before": {
            borderBottomColor: "#BF00FF",
          },
          "&::after": {
            borderBottomColor: "#BF00FF",
          },
        },
        "&.Mui-focused": {
          backgroundColor: "#E7EBF0",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "#1D1D1D",
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          "&.Mui-error": {
            color: "#fff",
            background: "#F1185C",
            letterSpacing: 0.8,
            fontSize: "0.8em",
            padding: "0 8px",
            margin: 0,
          },
        },
      },
    },
  },
  palette: {
    primary: {
      "50": "#43268b3b",
      "500": "#43268bb0",
      main: "#43268B",
      light: "#BF00FF",
      dark: "#000000",
      contrastText: "rgba(0, 0, 0, 0.87)",
    },
    background: {
      default: "#000",
      light: "#fff",
      paper: "#0A1929",
      primary: "#43268B",
    },
    common: {
      // black: "#1D1D1D",
      black: "#000",
      white: "#fff",
    },
    text: {
      light: "#FFAA01",
      primary: "#fff",
      secondary: "#FFAA01",
      dark: "#1D1D1D",
      disabled: "rgba(255, 255, 255, 0.5)",
    },
    grey: {
      "50": "#F3F6F9",
      "100": "#E7EBF0",
      "200": "#E0E3E7",
      "300": "#CDD2D7",
      "400": "#B2BAC2",
      "500": "#A0AAB4",
      "600": "#6F7E8C",
      "700": "#3E5060",
      "800": "#2D3843",
      "900": "#1A2027",
      A100: "#f5f5f5",
      A200: "#eeeeee",
      A400: "#bdbdbd",
      A700: "#616161",
    },
    secondary: {
      main: "#0CD6FF",
      light: "#FFAA01",
      dark: "#BF00FF",
      contrastText: "rgba(0, 0, 0, 0.87)",
    },
    action: {
      disabled: "#6F7E8C",
      disabledBackground: "#2D3843",
      disabledOpacity: 0.38,
    },
    error: {
      main: "#F1185C",
      light: "#ef5350",
      dark: "#c62828",
      contrastText: "#fff",
    },
  },
  shape: {
    borderRadius: 10,
    flat: 0,
  },
  typography: {
    fontFamily:
      '"Mulish","IBM Plex Sans",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
    htmlFontSize: 16,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightBold: 700,
    fontWeightExtraBold: 800,
  },
};

export const customRadioCheckboxStyle = {
  color: "#0CD6FF",
  "&.Mui-checked": {
    color: "#0CD6FF",
  },
};

export const customButtonStyle = (size?: string) => {
  return {
    fontWeight: "fontWeightBold",
    fontSize: 16,
    borderRadius: 0,
    px: size === "small" ? 4 : 6,
    py: size === "small" ? 1 : 2,
    my: size === "small" ? 0 : 3,
    "&:hover": {
      backgroundColor: "primary.light",
      color: "common.white",
    },
  };
};

export const zIndexes = {
  Bottom: -100,
  Base: 0,
  Above: 100,
  Top: 1000,
  Header: 1100,
};

// Ensure the EntainPattern sits above the black sections.
export const getZIndex = (bgcolor: string) => {
  return backgroundColorIsDark(bgcolor) ? zIndexes.Base : zIndexes.Above;
};

export const backgroundColorIsDark = (bgcolor: string) => {
  return bgcolor === "common.black" ||
    bgcolor === "background.default" ||
    bgcolor === "transparent" ||
    bgcolor === "black"
    ? true
    : false;
};

export const sectionBackgroundColors = {
  header: "background.default",
  logo: "transparent",
  intro: "transparent",
  eventInformation: "background.default",
  challengesPrizes: "background.primary",
  guestSpeakers: "transparent",
  partners: "background.primary",
  faq: "transparent",
  linkToRegisterButton: "background.primary", // THIS MUST BE SAME COLOUR AS SECTION IT IS UNDERNEATH
  footer: "primary.light",
};
